import styled from 'styled-components'
import theme from '../../themes/light'

export default styled.div`
  background: ${theme.background};
  width: 100%;
  max-width: 55rem;
  margin-top: 60px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex: 1 1 auto;
  flex-direction: row;
  align-items: start;
  justify-content: center;
`
